module.exports = __webpack_public_path__ + "media/bootstrap-icons/sticky-1d37a7f8.svg";